import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";
import { Main, Content } from "../../components/Layout";
import { ModalAddTask } from "../../components/Modal";
import useWrapper from "../../hooks/useWrapper";
import CalendarBig from "../../components/CalendarBig";
import useFormat from "../../hooks/utils/useFormat";

export default function Dashboard() {
  const { setbreadcrumb, me, config } = useWrapper();
  const [reload, setreload] = useState(false);
  const [loading, setloading] = useState(false);

  const [selectEvent, setselectEvent] = useState();
  const [events2, setevents2] = useState();

  const { stringToDate } = useFormat();

  useEffect(() => {
    (async function () {
      setloading(true);
      try {
        let _user_resources = "";
        me.resource.forEach((e, index) => {
          index > 0 && (_user_resources += ",");
          _user_resources += e.id;
        });

        const { data: _events } = await api.get(`calendars-dates?resourceFilter=true&active=1`, {
          ...config,
        });

        let _only_events = [];
        _events.forEach(__day => {
          __day.entries.forEach(__entry => {
            const _date = stringToDate(__day.date_start);
            _only_events.push({
              start: _date,
              end: _date,
              all_day: !!__entry.all_day,
              title: __entry.title,
              status: __entry.status,
              done: __entry.done,
              id: __entry.id,
            });
          });
        });

        setevents2(_only_events);
      } catch (__err) {
        console.log("__err", __err);
        toast.error("Problema ao tentar carregar a Agenda!");
      }
      setloading(false);
    })();
  }, [reload]);

  useEffect(() => {
    setbreadcrumb([{ label: "Agenda", title: true }]);
  }, []);

  return (
    <Main>
      <ModalAddTask
        reload={() => {
          setreload(!reload);
        }}
        itemId={selectEvent}
        show={!!selectEvent || selectEvent === ""}
        onHide={() => setselectEvent(null)}
      />
      <Content>
        <CalendarBig
          reload={reload}
          setreload={setreload}
          events={events2}
          onSelectEvent={__ev => {
            setselectEvent(__ev.id || "");
          }}
          loading={loading}
        />
      </Content>
    </Main>
  );
}
